<template>
  <vue-ckeditor
    :config="config"
    @fileUploadResponse="onFileUploadResponse($event)"
    v-model="formData.content" />
</template>

<script>
import API from '@/api'
import VueCkeditor from 'vue-ckeditor2'

export default {
  name: 'RichEditor',

  props: {
    content: {
      type: String,
      required: true
    }
  },

  components: {
    VueCkeditor
  },

  data () {
    return {
      formData: {
        content: '',
        attachs: []
      },
      config: {
        filebrowserImageUploadUrl: API.files.uploadUrl(),
        fileTools_requestHeaders: { Authorization: 'Bearer ' + this.$auth.token() },
        bodyClass: 'content',
        height: 650
      }
    }
  },

  mounted () {
    this.formData.content = this.content
  },

  watch: {
    'formData.content' () {
      this.$emit('change', this.formData)
    }
  },

  methods: {
    onFileUploadResponse (event) {
      let response = event.data.fileLoader.xhr

      if (response.status >= 200 && response.status < 300) {
        let data = JSON.parse(response.responseText.split('|'))

        this.formData.attachs.push({
          id: data.id,
          name: data.fileName
        })
      }
    }
  }
}
</script>
